// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77f95b07","732":"b9e186fd","977":"59a3d493"}[chunkId] + ".chunk.js";
};